<template>
  <b-navbar toggleable="md" type="dark" variant="dark" class="py-0">
    <b-navbar-toggle target="nav_collapse" />
    <b-navbar-brand :to="{ name: 'publicHome' }">
      <img src="@/assets/img/logo_39.png" width="222" height="39">
    </b-navbar-brand>
    <b-collapse id="nav_collapse" is-nav>
      <b-navbar-nav v-if="$route.path.indexOf('/secure') > -1 && this.$store.state.user_id !== false">
        <b-nav-item :to="{ name: 'secureArticles' }">
          {{ $t("navbar.articles") }}
        </b-nav-item>
        <b-nav-item :to="{ name: 'secureBlocks' }">
          {{ $t("navbar.blocks") }}
        </b-nav-item>
        <b-nav-item :to="{ name: 'securePhrases' }">
          {{ $t("navbar.phrases") }}
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav v-else>
        <b-nav-item :to="{ name: 'publicHome' }">
          Public
        </b-nav-item>
        <b-nav-item :to="{ name: 'secureHome' }">
          APP
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown v-if="this.$store.state.user_id !== false" variant="outline-secondary" :text="'<small>' + $t('navbar.aktives_project') + '</small><br/>'+aktiveProjectTitle" right class="py-0">
          <b-dropdown-header>{{ $t("navbar.projektauswahl_headline") }}</b-dropdown-header>
          <b-dropdown-item v-for="(item,i) in this.$store.state.projects" :key="i" @click="setCurrentProject(item.id)">
            <font-awesome-icon v-if="item.id == $store.state.current_project_id" icon="circle" fixed-width />
            <font-awesome-icon v-else icon="info" fixed-width />
            {{ item.name }}
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item :to="{ name: 'secureProjects' }" class="text-center">
            {{ $t("navbar.projektauswahl_liste_link") }}
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-form>
          <element v-if="this.$store.state.user_id !== false">
            <img :src="this.$store.state.user_data.picture" width="30" height="30">
            <span class="text-muted font-weight-light px-2">{{ this.$store.state.user_data.name }}</span>
            <b-button size="sm" variant="outline-secondary" @click="$auth.logout()">
              {{ $t("navbar.logout") }}
            </b-button>
          </element>
          <b-button v-else size="sm" variant="outline-secondary" @click="$auth.login()">
            {{ $t("navbar.login") }}
          </b-button>
        </b-nav-form>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>


<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    aktiveProjectTitle: function() {
      if ( this._.has(this.$store.state.projects, this.$store.state.current_project_id) ){
        return this.$store.state.projects[this.$store.state.current_project_id].name
      }
      return false

    }
  }
}
</script>
